import { SET_FLUTTER_APP } from "../actions/flutterInit"

export default function flutterInit(state = {}, action = {}) {
  switch (action.type) {
    case SET_FLUTTER_APP:
      return {
        ...state,
        flutterApp: action.payload
      }

    default:
      return { ...state }
  }
}
